// import { Earcut } from 'three/src/extras/Earcut.js';
import * as THREE from 'three';
import earcut = require('earcut');

import { triangle } from '../math/triangle';

export default class triangulation {
  // Earcut.triangulate

  position = (area: Array<THREE.Vector2>): triangle[] => {
    // var triangles = earcut([10,0, 0,50, 60,60, 70,10]);
    const position = [];
    for (let i = 0; i < area.length; i += 1) {
      position.push(area[i].x);
      position.push(area[i].y);
    }
    const positionArray = earcut(position);

    const arrayChunk = ([...array], size = 1) => array.reduce((acc, value, index) => (index % size ? acc : [...acc, array.slice(index, index + size)]), []);
    return arrayChunk(positionArray, 3).map((element: number[]) => new triangle(area[element[0]], area[element[1]], area[element[2]]));
  }
}
